<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="10" class="d-flex">
        <site-filter
          siteListGetter="aiFactory/getSiteConnectors"
          itemValue="site.id"
          itemText="site.name"
          store="aiFactory"
          storeGetter="getSelectedSites"
          :multiple="false"
          :dependsOnSiteGroups="false"
        />
      </v-col>
      <!-- <v-col cols="4">
        <date-filter store="newsRadar" periodType="past-and-today" range="1" />
      </v-col> -->
      <v-col cols="2" class="d-flex justify-end">
        <apply-filters :disabled="disableSearch" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter.vue";
import SiteFilter from "@/components/common/filters/SiteFilter.vue";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
    SiteFilter,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { isLoading } = useAxios();

    const page = reactive({
      isInitialized: false,
    });

    // =>  METHODS

    // =>  COMPUTED
    const site = computed(() => {
      const value = store.getters["aiFactory/getSelectedSites"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });

    const disableSearch = computed(() => {
      return (site.value ?? 0) === 0 || isLoading.value;
    });

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      page.isInitialized = true;
    });

    // =>  DATA
    return {
      disableSearch,
      site,
    };
  },
};
</script>

<style></style>
